import { Card, Select } from 'antd';
import React, { useState } from 'react';

const { Option } = Select;

function TermsOfService() {
    const [language, setLanguage] = useState('en');

    const content = {
        en: {
            title: 'Terms of Service',
            lastUpdated: 'Last Updated: December 16, 2024',
            sections: [
                {
                    title: '1. Acceptance of Terms',
                    content:
                        'By accessing and using ReEvent ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use the Service.',
                },
                {
                    title: '2. Description of Service',
                    content:
                        'ReEvent is an event management platform that allows users to create, manage, and track events and participant attendance. The Service includes both free and premium subscription tiers.',
                },
                {
                    title: '3. User Accounts',
                    content:
                        'You must create an account to use the Service. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.',
                },
                {
                    title: '4. Subscription and Payment',
                    content:
                        'ReEvent offers a free tier (limited to 1 event) and premium subscriptions ($9/month or $88/year). Premium subscriptions are processed through Paddle. Subscriptions automatically renew unless cancelled. Refunds are handled according to our refund policy.',
                },
                {
                    title: '5. User Content',
                    content:
                        'You retain all rights to the content you create and upload to the Service (events, participant data, etc.). By using the Service, you grant ReEvent a license to store, process, and display your content solely for the purpose of providing the Service to you.',
                },
                {
                    title: '6. Prohibited Uses',
                    content:
                        'You may not use the Service for any illegal purposes, to transmit harmful code, to harass others, or to violate any applicable laws or regulations. We reserve the right to terminate accounts that violate these terms.',
                },
                {
                    title: '7. Service Availability',
                    content:
                        'We strive to provide reliable service but do not guarantee uninterrupted access. The Service may be temporarily unavailable for maintenance, updates, or due to circumstances beyond our control.',
                },
                {
                    title: '8. Limitation of Liability',
                    content:
                        'ReEvent is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the Service, including but not limited to data loss, service interruptions, or unauthorized access to your account.',
                },
                {
                    title: '9. Changes to Terms',
                    content:
                        'We reserve the right to modify these Terms of Service at any time. We will notify users of significant changes via email. Continued use of the Service after changes constitutes acceptance of the new terms.',
                },
                {
                    title: '10. Refund Policy',
                    content:
                        'We offer a 30-day money-back guarantee for all premium subscriptions. If you are not satisfied with the Service within 30 days of your initial purchase, you may request a full refund by contacting support@reevent.io. Refunds for subscription renewals are handled on a case-by-case basis. Please note that refunds may take 5-10 business days to process.',
                },
                {
                    title: '11. Termination',
                    content:
                        'You may terminate your account at any time through the Settings page. We reserve the right to suspend or terminate accounts that violate these terms or for any other reason at our discretion.',
                },
                {
                    title: '12. Governing Law',
                    content:
                        'These Terms of Service are governed by the laws of Iceland. Any disputes shall be resolved in the courts of Iceland.',
                },
                {
                    title: '13. Contact Information',
                    content:
                        'If you have any questions about these Terms of Service, please contact us at support@reevent.io.',
                },
            ],
        },
        is: {
            title: 'Þjónustuskilmálar',
            lastUpdated: 'Síðast uppfært: 16. desember 2024',
            sections: [
                {
                    title: '1. Samþykki skilmála',
                    content:
                        'Með því að nota ReEvent ("þjónustuna") samþykkir þú að vera bundinn af skilmálum þessa samnings. Ef þú samþykkir ekki þessa þjónustuskilmála skaltu ekki nota þjónustuna.',
                },
                {
                    title: '2. Lýsing á þjónustu',
                    content:
                        'ReEvent er viðburðastjórnunarkerfi sem gerir notendum kleift að búa til, stjórna og fylgjast með viðburðum og mætingu þátttakenda. Þjónustan inniheldur bæði ókeypis og áskriftarstig.',
                },
                {
                    title: '3. Notendareikningar',
                    content:
                        'Þú verður að búa til reikning til að nota þjónustuna. Þú berð ábyrgð á að halda innskráningarupplýsingum þínum trúnaðarmáli og fyrir öllum athöfnum sem eiga sér stað undir reikningnum þínum. Þú samþykkir að tilkynna okkur strax um óheimila notkun á reikningnum þínum.',
                },
                {
                    title: '4. Áskrift og greiðsla',
                    content:
                        'ReEvent býður upp á ókeypis stig (takmarkað við 1 viðburð) og áskriftir ($9/mánuð eða $88/ár). Áskriftir eru afgreiddar í gegnum Paddle. Áskriftir endurnýjast sjálfkrafa nema þeim sé sagt upp. Endurgreiðslur eru meðhöndlaðar samkvæmt endurgreiðslustefnu okkar.',
                },
                {
                    title: '5. Notendaefni',
                    content:
                        'Þú heldur öllum réttindum að efninu sem þú býrð til og hleður upp í þjónustuna (viðburði, gögn þátttakenda o.s.frv.). Með því að nota þjónustuna veitir þú ReEvent leyfi til að geyma, vinna úr og birta efni þitt eingöngu í þeim tilgangi að veita þér þjónustuna.',
                },
                {
                    title: '6. Bönnuð notkun',
                    content:
                        'Þú mátt ekki nota þjónustuna í ólöglegum tilgangi, til að senda skaðlegan kóða, til að áreita aðra eða til að brjóta í bága við gildandi lög eða reglur. Við áskildum okkur rétt til að segja upp reikningum sem brjóta gegn þessum skilmálum.',
                },
                {
                    title: '7. Framboð þjónustu',
                    content:
                        'Við leitumst við að veita áreiðanlega þjónustu en ábyrgjumst ekki ótruflaðan aðgang. Þjónustan getur verið tímabundið óaðgengileg vegna viðhalds, uppfærslna eða vegna aðstæðna sem eru utan okkar stjórnar.',
                },
                {
                    title: '8. Takmörkun á ábyrgð',
                    content:
                        'ReEvent er veitt "eins og er" án nokkurra ábyrgða. Við berum ekki ábyrgð á tjóni sem stafar af notkun þinni á þjónustunni, þar með talið en ekki takmarkað við gagnatap, truflun á þjónustu eða óheimilan aðgang að reikningnum þínum.',
                },
                {
                    title: '9. Breytingar á skilmálum',
                    content:
                        'Við áskildum okkur rétt til að breyta þessum þjónustuskilmálum hvenær sem er. Við munum tilkynna notendum um verulegar breytingar með tölvupósti. Áframhaldandi notkun á þjónustunni eftir breytingar jafngildir samþykki á nýju skilmálunum.',
                },
                {
                    title: '10. Endurgreiðslustefna',
                    content:
                        'Við bjóðum upp á 30 daga peningaendurgreiðsluábyrgð fyrir allar áskriftir. Ef þú ert ekki ánægð/ur með þjónustuna innan 30 daga frá upphaflegum kaupum geturðu óskað eftir fullri endurgreiðslu með því að hafa samband við support@reevent.io. Endurgreiðslur fyrir endurnýjanir áskrifta eru meðhöndlaðar í hverju tilviki fyrir sig. Vinsamlegast athugaðu að endurgreiðslur geta tekið 5-10 virka daga að vinna.',
                },
                {
                    title: '11. Uppsögn',
                    content:
                        'Þú getur sagt upp reikningnum þínum hvenær sem er í gegnum stillingasíðuna. Við áskildum okkur rétt til að stöðva eða segja upp reikningum sem brjóta gegn þessum skilmálum eða af öðrum ástæðum að eigin geðþótta.',
                },
                {
                    title: '12. Gildandi lög',
                    content:
                        'Þessir þjónustuskilmálar eru stjórnaðir af lögum Íslands. Öll ágreiningur skal leystur fyrir dómstólum á Íslandi.',
                },
                {
                    title: '13. Tengiliðaupplýsingar',
                    content:
                        'Ef þú hefur spurningar um þessa þjónustuskilmála, vinsamlegast hafðu samband við okkur á support@reevent.io.',
                },
            ],
        },
    };

    const currentContent = content[language];

    return (
        <div className="container main">
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '24px',
                    }}
                >
                    <h1>{currentContent.title}</h1>
                    <Select
                        value={language}
                        onChange={setLanguage}
                        style={{ width: 150 }}
                    >
                        <Option value="en">English</Option>
                        <Option value="is">Íslenska</Option>
                    </Select>
                </div>

                <Card>
                    <p style={{ color: '#666', marginBottom: '24px' }}>
                        {currentContent.lastUpdated}
                    </p>

                    {currentContent.sections.map((section, index) => (
                        <div key={index} style={{ marginBottom: '24px' }}>
                            <h3>{section.title}</h3>
                            <p style={{ lineHeight: '1.6' }}>{section.content}</p>
                        </div>
                    ))}
                </Card>
            </div>
        </div>
    );
}

export default TermsOfService;

